// ─────────────────────────────────────────────────────────────────────────────
// PoliciesTab.js — ASSIGNED POLICIES cards (name + type + enforcement badge).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../UserDetailModal.module.css";

export default function PoliciesTab({ detail }) {
  return (
    <div className={styles.tab}>
      <div className={styles.sectionLabel}>Assigned Policies</div>
      <div className={styles.list}>
        {detail.policies.map((p, i) => (
          <div key={i} className={styles.policyCard}>
            <div className={styles.policyMeta}>
              <span className={styles.policyName}>{p.name}</span>
              <span className={styles.policyType}>{p.type}</span>
            </div>
            <span className={styles.statusPill} style={{ color: "var(--accent)" }}>
              <span className={styles.statusDot} style={{ background: "var(--accent)" }} />
              {p.state}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
